// extracted by mini-css-extract-plugin
module.exports = {"avatar":"a2c79c7e7d--avatar--ceW9Q","clickable":"a2c79c7e7d--clickable--jjxbB","company":"a2c79c7e7d--company--MXKHY"};